// src/components/orders/StatusBadge.jsx
import { TONE_CLASSES, localStatusMeta } from "../ui/orderStatuses";

const SHIPPING_TONES = [
  // ordre important : "en cours de livraison" / "non livré" ne sont pas livrés
  { match: /(retour|return|refus)/i, tone: "danger" },
  { match: /(annul|cancel)/i, tone: "danger" },
  { match: /(en cours|non livr|pas livr|transit|progress|ramass|exp[ée]di)/i, tone: "brand" },
  { match: /^(livr|delivered)/i, tone: "success" },
];

function shippingTone(value) {
  const text = String(value || "").trim();
  const hit = SHIPPING_TONES.find((t) => t.match.test(text));
  return hit ? hit.tone : "neutral";
}

function Pill({ tone, children, dot = true }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ${
        TONE_CLASSES[tone] || TONE_CLASSES.neutral
      }`}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />}
      {children}
    </span>
  );
}

export function StatusBadge({ local_status, shipping_status, auto_confirmed }) {
  const meta = localStatusMeta(local_status || "new");
  const showShipping =
    shipping_status && !["pending", "non"].includes(String(shipping_status).toLowerCase());

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Pill tone={meta.tone}>{meta.label}</Pill>
      {showShipping ? <Pill tone={shippingTone(shipping_status)}>{shipping_status}</Pill> : null}
      {auto_confirmed ? <Pill tone="brand">Auto-confirmée</Pill> : null}
    </div>
  );
}
